import React from 'react';
import { useI18n } from '../i18n/LanguageContext';

const CONTENT = {
  ro: {
    title: 'Politica de cookie-uri',
    lead:
      'Acest site foloseste un set minim de stocari locale necesare pentru functionare si, optional, cookies sau tehnologii similare pentru analytics doar dupa consimtamant.',
    sections: [
      {
        title: 'Operator',
        bullets: [
          'Aceasta politica se aplica site-ului operat de YOUNGER KAROM PRODUCTION COMPANY SRL, CUI 4219179, inregistrata la Registrul Comertului sub nr. J40/15256/1993.',
        ],
      },
      {
        title: 'Stocari necesare',
        bullets: [
          'Preferinta de limba, pentru a afisa site-ul in romana sau engleza.',
          'Optiunea privind cookies, pentru a retine daca ai acceptat sau ai refuzat analytics.',
        ],
      },
      {
        title: 'Analytics optionale',
        bullets: [
          'Analytics optionale sunt activate numai daca alegi sa accepti analytics.',
          'Scopul este analiza interactiunilor cu site-ul, imbunatatirea continutului si identificarea problemelor de utilizare.',
        ],
      },
      {
        title: 'Cum iti poti schimba alegerea',
        bullets: [
          'Poti deschide oricand setarile de cookies din footer.',
          'Daca retragi consimtamantul pentru analytics, site-ul va opri incarcarea instrumentelor analitice optionale la urmatoarea reincarcare a paginii.',
        ],
      },
    ],
  },
  en: {
    title: 'Cookie Policy',
    lead:
      'This website uses a minimal set of local storage items required for operation and, optionally, analytics cookies or similar technologies only after consent.',
    sections: [
      {
        title: 'Controller',
        bullets: [
          'This policy applies to the website operated by YOUNGER KAROM PRODUCTION COMPANY SRL, tax ID code 4219179, registered with the Trade Register under no. J40/15256/1993.',
        ],
      },
      {
        title: 'Necessary storage',
        bullets: [
          'Language preference, used to display the website in Romanian or English.',
          'Cookie choice, used to remember whether you accepted or rejected analytics.',
        ],
      },
      {
        title: 'Optional analytics',
        bullets: [
          'Optional analytics are enabled only if you choose to accept analytics.',
          'Its purpose is to analyze interactions with the website, improve content, and identify usability issues.',
        ],
      },
      {
        title: 'How to change your choice',
        bullets: [
          'You can open cookie settings at any time from the footer.',
          'If you withdraw consent for analytics, the website will stop loading optional analytics tools on the next page reload.',
        ],
      },
    ],
  },
};

export default function CookiePolicy() {
  const { lang } = useI18n();
  const content = CONTENT[lang] || CONTENT.ro;

  return (
    <section className="yk-page yk-legalPage">
      <header className="yk-card yk-legalCard">
        <h1 className="yk-h1">{content.title}</h1>
        <p className="yk-text">{content.lead}</p>
      </header>

      {content.sections.map((section) => (
        <article key={section.title} className="yk-card yk-legalCard yk-legalSection">
          <h2 className="yk-h2">{section.title}</h2>
          <ul className="yk-legalList">
            {section.bullets.map((bullet) => (
              <li key={bullet}>{bullet}</li>
            ))}
          </ul>
        </article>
      ))}
    </section>
  );
}